/* eslint-disable sort-keys */
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['row']);

const accentInheritSx = {
  '& .line-item-config__accent': {
    color: 'inherit',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'semibold',
    lineHeight: 'inherit',
  },
};

export const lineItemConfigurationStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    row: {
      margin: 0,
    },
  },
  variants: {
    cartItem: {
      row: {
        color: 'greyscale90Alpha.70',
        fontFamily: 'body',
        fontSize: {base: '13px', lg: '12px'},
        fontWeight: '400',
        lineHeight: 1.2,
        sx: {
          '.cart-flyout__items-container &': {
            fontSize: {base: '12px', lg: '12px'},
          },
          '& .cart-item__config-label, & .cart-item__config-value, & .cart-item__config-label > span':
            {
              color: 'inherit',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
            },
          ...accentInheritSx,
        },
      },
    },
    confirmationLineItem: {
      row: {
        color: 'grayAlpha.70',
        fontFamily: 'body',
        fontSize: {base: '13px', lg: '12px'},
        fontWeight: 400,
        lineHeight: 1.2,
        sx: {
          '& .confirmation-line-item__config-label, & .confirmation-line-item__config-value, & .confirmation-line-item__config-label > span':
            {
              color: 'inherit',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
            },
          ...accentInheritSx,
        },
      },
    },
  },
  defaultProps: {
    variant: 'cartItem',
  },
});

export default lineItemConfigurationStyles;
